<template>
  <NuxtLink :to="'/'+slug" class="image-and-title">
    <img :src="image" :alt="title || ''" class="image">
    <Heading tag="h2" class="title">{{ title }}</Heading>
  </NuxtLink>
</template>

<script>
import Heading from "~/components/atoms/Heading.vue";

export default {
  components: {Heading},
  props: ['image', 'title', 'entity', 'slug']
}

</script>

<style scoped lang="scss">
img {
  width: 56px;
  height: auto;
  margin: auto;

  @include smd {
    width: 40px;
  }
}

.title {
  min-width: 133px;
  text-align: center;
  color: $space-black;
  font-size: 13px;
  font-weight: 400;

  @include smd {
    min-width: 88px;
    font-size: 10px;
  }
}

.image-and-title {
  text-align: center;
}
</style>
